<template lang="pug">
  svg.svg-sprite-sheet(xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="0" height="0")
    defs
      symbol(id="butter-melted" viewBox="0 0 50 25.82" preserveAspectRatio="xMidYMax meet")
        path.butter-melted-cls-1(d="M.55.5c0,.3-.05.59-.05.89A23.39,23.39,0,0,0,3,11.93,24.56,24.56,0,0,0,25,25.32,24.56,24.56,0,0,0,47.07,11.8,23.38,23.38,0,0,0,49.5,1.39c0-.3,0-.59,0-.89Z")
        path.butter-melted-cls-2(d="M2.5,9c0,.19,0-.19,0,0,0,2.41,2.75,5.26,4.09,7.28C9.93,21.34,16.92,24.82,25,24.82S40.15,21.3,43.47,16.2c1.3-2,4-4.82,4-7.2,0-.19,0,.19,0,0Z")
      symbol(id="cinnamon" viewBox="0 0 13 39" preserveAspectRatio="xMidYMax meet")
        rect.cinnamon-cls-1(x="0.5" y="4.5" width="12" height="34" rx="1")
        rect.cinnamon-cls-2(x="1.5" y="0.5" width="10" height="5" rx="2")
        ellipse.cinnamon-cls-3(cx="5" cy="1.5" rx="1" ry="0.5")
        ellipse.cinnamon-cls-3(cx="8" cy="1.5" rx="1" ry="0.5")
        ellipse.cinnamon-cls-3(cx="8" cy="3.5" rx="1" ry="0.5")
        ellipse.cinnamon-cls-3(cx="5" cy="3.5" rx="1" ry="0.5")
      symbol(id="egg" viewBox="0 0 17.5 22.5" preserveAspectRatio="xMidYMax meet")
        ellipse.egg-cls-1(cx="8.75" cy="11.25" rx="8.25" ry="10.75")
      symbol(id="flour" viewBox="0 0 41 61" preserveAspectRatio="xMidYMax meet")
        rect.flour-cls-1(x="0.5" y="0.5" width="40" height="60")
        rect.flour-cls-2(x="0.5" y="8" width="40" height="27")
        polyline.flour-cls-3(id="stem" points="11.51 30.5 16.09 25.93 26.74 15.3")
        path.flour-cls-3(id="leaf-1" d="M16.73,24.25a1.35,1.35,0,0,1-1.09,1.65,1.29,1.29,0,0,1-1.21-1.36c0-1.39.26-1.86,1.06-2.41C16.14,22.42,16.5,23.51,16.73,24.25Z")
        path.flour-cls-3(id="leaf-2" d="M18.09,27.61a2,2,0,0,1-2-.95c-.23-.56.17-.89.9-1.25s1.61-.16,2.87,1A1.82,1.82,0,0,1,18.09,27.61Z")
        path.flour-cls-3(id="leaf-3" d="M18.67,22c.08.88-.52,2-1.13,2s-1.24-.91-1.24-1.72a2.25,2.25,0,0,1,1.09-2.05A2.43,2.43,0,0,1,18.67,22Z")
        path.flour-cls-3(id="leaf-4" d="M20,25.71a2,2,0,0,1-2-.95c-.24-.56.18-.89.93-1.25s1.7-.17,2.88,1C21.7,25.13,20.4,25.67,20,25.71Z")
        path.flour-cls-3(id="leaf-5" d="M20.57,20.38c.07.8-.44,1.75-1.06,1.75a1.37,1.37,0,0,1-1.28-1.38c0-1.4.44-2.12,1.13-2.38A2.56,2.56,0,0,1,20.57,20.38Z")
        path.flour-cls-3(id="leaf-6" d="M21.92,23.81a2,2,0,0,1-2-.95c-.24-.56.18-.89.93-1.25s1.63-.17,2.81,1C23.78,23.23,22.38,23.77,21.92,23.81Z")
        path.flour-cls-3(id="leaf-7" d="M22.43,18.55c.09.81-.48,1.65-1.09,1.65s-1.27-.91-1.21-1.72a2.25,2.25,0,0,1,1-2C21.66,16.53,22.33,17.59,22.43,18.55Z")
        path.flour-cls-3(id="leaf-8" d="M23.79,21.94a2,2,0,0,1-2-.94c-.24-.57.17-.9.92-1.25s1.71-.17,2.89,1C25.54,21.37,24.24,21.91,23.79,21.94Z")
        path.flour-cls-3(id="leaf-9" d="M24.33,16.65a1.35,1.35,0,0,1-1.09,1.65A1.28,1.28,0,0,1,22,17c0-1.4.26-1.87,1.06-2.42C23.74,14.82,24.1,15.91,24.33,16.65Z")
        path.flour-cls-3(id="leaf-10" d="M25.47,20a1.73,1.73,0,0,1-1.83-1c-.24-.56.18-.89.92-1.25s1.71-.17,2.89,1.09C27.27,19.58,26.08,20,25.47,20Z")
        path.flour-cls-3(id="leaf-11" d="M26.3,15.19a1.36,1.36,0,0,1-1.43,1.31,1.23,1.23,0,0,1-.79-1.75,2.82,2.82,0,0,1,1.68-1.92C26.53,13.26,26.29,14.41,26.3,15.19Z")
        path.flour-cls-3(id="leaf-12" d="M27.67,17.91a2,2,0,0,1-2-.38c-.48-.38-.09-.9.5-1.47.4-.38,1.43-.72,3,.09C29.17,16.86,28.25,17.72,27.67,17.91Z")
        path.flour-cls-3(id="leaf-13" d="M28.92,14.85c-.5.63-1.45,1-1.9.63s-.94-1.73,0-2.26a3.61,3.61,0,0,1,2.44-.66A3.25,3.25,0,0,1,28.92,14.85Z")
      symbol(id="milk" viewBox="0 0 69.03 83" preserveAspectRatio="xMidYMax meet")
        path.milk-cls-1(d="M64.56,25.39A22.74,22.74,0,0,0,42.49,5.5h-19a21.36,21.36,0,0,0-21,20L.53,62.53a18.84,18.84,0,0,0,19,20h31A17.69,17.69,0,0,0,68.42,62.61ZM53.49,41.5c-2.75,0-5.23-4.73-5.5-10.5s1.07-10.95,3-11.5,4.4,4.18,5.5,10.5S56.24,41.5,53.49,41.5Z")
        path.milk-cls-2(d="M64.56,25.39A22.74,22.74,0,0,0,42.49,5.5h-19a21.36,21.36,0,0,0-21,20L.53,62.53a18.84,18.84,0,0,0,19,20h31A17.69,17.69,0,0,0,68.42,62.61ZM53.49,41.5c-2.75,0-5.23-4.73-5.5-10.5s1.07-10.95,3-11.5,4.4,4.18,5.5,10.5S56.24,41.5,53.49,41.5Z")
        rect.milk-cls-1(x="21.49" y="0.5" width="26" height="5" rx="2")
        rect.milk-cls-2(x="21.49" y="0.5" width="26" height="5" rx="2")
      symbol(id="salt" viewBox="0 0 26.69 34.75" preserveAspectRatio="xMidYMax meet")
        path.salt-cls-1(d="M26.28,29.42a4.3,4.3,0,0,1-4.36,5h-17a4.46,4.46,0,0,1-4.52-5l2-21a5.64,5.64,0,0,1,5.49-5h10a5.86,5.86,0,0,1,5.64,5Z")
        path.salt-cls-2(d="M26.28,29.42a4.3,4.3,0,0,1-4.36,5h-17a4.46,4.46,0,0,1-4.52-5l2-21a5.64,5.64,0,0,1,5.49-5h10a5.86,5.86,0,0,1,5.64,5Z")
        path.salt-cls-1(d="M20.42,3.38c0,1.64-2.25,3-5,3h-5c-2.75,0-5-1.36-5-3s2.25-3,5-3h5C18.17.38,20.42,1.73,20.42,3.38Z")
        path.salt-cls-2(d="M20.42,3.38c0,1.64-2.25,3-5,3h-5c-2.75,0-5-1.36-5-3s2.25-3,5-3h5C18.17.38,20.42,1.73,20.42,3.38Z")
        polygon.salt-cls-3(points="7.42 30.88 5.42 30.88 7.42 8.88 9.42 8.88 7.42 30.88")
        rect.salt-cls-3(x="12.42" y="8.88" width="2" height="22")
        polygon.salt-cls-3(points="21.42 30.88 19.42 30.88 17.42 8.88 19.42 8.88 21.42 30.88")
        ellipse.salt-cls-0(cx="12.42" cy="2.37" rx="1" ry="0.5")
        ellipse.salt-cls-0(cx="10.42" cy="4.37" rx="1" ry="0.5")
        ellipse.salt-cls-0(cx="15.42" cy="4.37" rx="1" ry="0.5")
      symbol(id="sour-cream" viewBox="0 0 45 42" preserveAspectRatio="xMidYMax meet")
        path.sour-cream-cls-1(d="M43.5.5H1.5a1,1,0,0,0,0,2h1l3,39h34l3-39h1a1,1,0,0,0,0-2Z")
      symbol(id="sugar" viewBox="0 0 41 61" preserveAspectRatio="xMidYMax meet")
        rect.sugar-cls-1(x="0.5" y="0.5" width="40" height="60")
        rect.sugar-cls-2(x="0.5" y="24" width="40" height="27")
        polygon.sugar-cls-3(points="17.32 27 14.15 32.5 17.32 38 23.68 38 26.85 32.5 23.68 27 17.32 27")
        line.sugar-cls-3(x1="14.5" y1="32.5" x2="20.5" y2="32.5")
        line.sugar-cls-3(x1="23.5" y1="37.5" x2="20.5" y2="32.5")
        line.sugar-cls-3(x1="23.5" y1="27.5" x2="20.5" y2="32.5")
        polygon.sugar-cls-3(points="23.32 35 20.15 40.5 23.32 46 29.68 46 32.85 40.5 29.68 35 23.32 35")
        line.sugar-cls-3(x1="20.5" y1="40.5" x2="26.5" y2="40.5")
        line.sugar-cls-3(x1="29.5" y1="45.5" x2="26.5" y2="40.5")
        line.sugar-cls-3(x1="29.5" y1="35.5" x2="26.5" y2="40.5")
        polygon.sugar-cls-3(points="12.32 35 9.15 40.5 12.32 46 18.68 46 21.85 40.5 18.68 35 12.32 35")
        line.sugar-cls-3(x1="9.5" y1="40.5" x2="15.5" y2="40.5")
        line.sugar-cls-3(x1="18.5" y1="45.5" x2="15.5" y2="40.5")
        line.sugar-cls-3(x1="18.5" y1="35.5" x2="15.5" y2="40.5")
      symbol(id="yeast" viewBox="0 0 36 23.88" preserveAspectRatio="xMidYMax meet")
        rect.yeast-cls-1(x="0.5" y="3.37" width="35" height="20" rx="9")
        rect.yeast-cls-2(x="6.5" y="0.37" width="22" height="4" rx="1")
</template>

<script>
export default {
  name: 'svg-sprite-sheet',
};
</script>

<style lang="scss">
.svg-sprite-sheet {
  display: none;

  .butter-melted-cls-1 {
    fill: var(--fill-color-1, none);
    stroke: var(--stroke-color-1, #000);
    stroke-width: var(--stroke-width-1, 0.5px);
    stroke-miterlimit: 10;
  }
  .butter-melted-cls-2 {
    fill: var(--fill-color-1, #fcee21);
    stroke: var(--stroke-color-1, none);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 4;
  }

  .cinnamon-cls-1 {
    fill: var(--fill-color-1, #a67c52);
    stroke: var(--stroke-color-1, #000);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 10;
  }
  .cinnamon-cls-2 {
    fill: var(--fill-color-2, #000);
    stroke: var(--stroke-color-2, #000);
    stroke-width: var(--stroke-width-2, 1px);
    stroke-miterlimit: 10;
  }
  .cinnamon-cls-3 {
    fill: var(--fill-color-3, #fff);
    stroke: var(--stroke-color-3, none);
    stroke-width: var(--stroke-width-3, 1px);
    stroke-miterlimit: 4;
  }

  .egg-cls-1 {
    fill: var(--fill-color-1, #fff);
    stroke: var(--stroke-color-1, #000);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 10;
  }

  .flour-cls-1 {
    fill: var(--fill-color-1, #c1272d);
    stroke: var(--stroke-color-1, #000);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 10;
  }
  .flour-cls-2 {
    fill: var(--fill-color-2, #fff);
    stroke: var(--stroke-color-2, #000);
    stroke-width: var(--stroke-width-2, 1px);
    stroke-miterlimit: 10;
  }
  .flour-cls-3 {
    fill: var(--fill-color-2, none);
    stroke: var(--stroke-color-2, #000);
    stroke-width: var(--stroke-width-2, 0.5px);
    stroke-miterlimit: 10;
  }

  .milk-cls-1 {
    fill: var(--fill-color-1, #fff);
    stroke: var(--stroke-color-1, none);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 4;
  }
  .milk-cls-2 {
    fill: var(--fill-color-2, none);
    stroke: var(--stroke-color-2, #000);
    stroke-width: var(--stroke-width-2, 1px);
    stroke-miterlimit: 10;
  }

  .salt-cls-1 {
    fill: var(--fill-color-1, #f2f2f2);
    stroke: var(--stroke-color-1, none);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 4;
  }
  .salt-cls-2 {
    fill: var(--fill-color-2, none);
    stroke: var(--stroke-color-2, #000);
    stroke-width: var(--stroke-width-2, 0.75px);
    stroke-miterlimit: 10;
  }
  .salt-cls-3 {
    fill: var(--fill-color-3, #4d4d4d);
    stroke: var(--stroke-color-3, none);
    stroke-width: var(--stroke-width-3, 1px);
    stroke-miterlimit: 4;
  }

  .sour-cream-cls-1 {
    fill: var(--fill-color-1, #fff);
    stroke: var(--stroke-color-1, #000);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 10;
  }

  .sugar-cls-1 {
    fill: var(--fill-color-1, #29abe2);
    stroke: var(--stroke-color-1, #000);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 10;
  }
  .sugar-cls-2 {
    fill: var(--fill-color-2, #fff);
    stroke: var(--stroke-color-2, #000);
    stroke-width: var(--stroke-width-2, 1px);
    stroke-miterlimit: 10;
  }
  .sugar-cls-3 {
    fill: var(--fill-color-3, #fff);
    stroke: var(--stroke-color-3, #000);
    stroke-width: var(--stroke-width-3, 0.25px);
    stroke-miterlimit: 10;
  }

  .yeast-cls-1 {
    fill: var(--fill-color-1, #c69c6d);
    stroke: var(--stroke-color-1, #000);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 10;
  }
  .yeast-cls-2 {
    fill: var(--fill-color-2, #b3b3b3);
    stroke: var(--stroke-color-2, #000);
    stroke-width: var(--stroke-width-2, 0.75px);
    stroke-miterlimit: 10;
  }

}
</style>
